module.exports = __webpack_public_path__ + "static/media/Bitcoin-Accounting.3d6ca5d4.png";